module.exports = __webpack_public_path__ + "static/media/f3.ab155099.png";